import { createSlice } from "@reduxjs/toolkit";

const dragModeSlice = createSlice({
  name: "dragMode",
  initialState: {
    isActive: false,
    draggableSensorId: null,
    isLocationActive: false,
  },
  reducers: {
    setDraggableMode(state, action) {
      state.isActive = true;
      state.draggableSensorId = action.payload;
    },
    resetDraggableMode(state) {
      state.isActive = false;
      state.draggableSensorId = null;
    },
    setLocationMode(state, action) {
      state.isLocationActive = action.payload;
    },
  },
});

export const { setDraggableMode, resetDraggableMode, setLocationMode } =
  dragModeSlice.actions;

export default dragModeSlice.reducer;
